import { Routes, Route, Navigate } from 'react-router-dom'
import RequireAuth from './auth/RequireAuth'
import AppShell from './layout/AppShell'
import LoginPage from './pages/Login/LoginPage'
import FacturarPage from './pages/Facturar/FacturarPage'
import DocumentosPage from './pages/Documentos/DocumentosPage'
import ClientesPage from './pages/Clientes/ClientesPage'
import ProductosPage from './pages/Productos/ProductosPage'
import ServiciosPage from './pages/Servicios/ServiciosPage'
import DepositosPage from './pages/Depositos/DepositosPage'
import MonedasPage from './pages/Monedas/MonedasPage'
import CotizacionesPage from './pages/Cotizaciones/CotizacionesPage'
import FormasPagoPage from './pages/FormasPago/FormasPagoPage'
import CajaPage from './pages/Caja/CajaPage'
import PerfilPage from './pages/Perfil/PerfilPage'
import { PERM } from './auth/permissions'

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route
        element={
          <RequireAuth>
            <AppShell />
          </RequireAuth>
        }
      >
        <Route index element={<Navigate to="/facturar" replace />} />
        <Route path="/facturar" element={<RequireAuth permission={PERM.FACTURACION_AGIL}><FacturarPage /></RequireAuth>} />
        <Route path="/documentos" element={<DocumentosPage />} />
        <Route path="/caja" element={<CajaPage />} />
        <Route path="/clientes" element={<ClientesPage />} />
        <Route path="/productos" element={<ProductosPage />} />
        <Route path="/servicios" element={<ServiciosPage />} />
        <Route path="/depositos" element={<DepositosPage />} />
        <Route path="/monedas" element={<MonedasPage />} />
        <Route path="/cotizaciones" element={<CotizacionesPage />} />
        <Route path="/formas-pago" element={<FormasPagoPage />} />
        <Route path="/perfil" element={<PerfilPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}
